import store from '../src/store'

let getAppUrl = () => {
     if (store.getters.isStatewide) {
          return  process.env.VUE_APP_STATEWIDE_APPURL ? process.env.VUE_APP_STATEWIDE_APPURL : 'https://stw.partssearch.com.au'
     }
     if (store.getters['currentCompany/isCCNSW']) {
          return  process.env.VUE_APP_CCNSW_APPURL ? process.env.VUE_APP_CCNSW_APPURL : 'https://ccnsw.partssearch.com.au'
     }
     return  process.env.VUE_APP_APPURL ? process.env.VUE_APP_APPURL : 'https://app.partssearch.com.au'
}

let getHomeUrl = () => {
     if (store.getters.isStatewide) {
          return  process.env.VUE_APP_STATEWIDE_HomeURL ? process.env.VUE_APP_STATEWIDE_HomeURL : 'https://statewide.partssearch.com.au'
     }
     if (store.getters['currentCompany/isCCNSW']) {
          return  process.env.VUE_APP_CCNSW_HomeURL ? process.env.VUE_APP_CCNSW_HomeURL : 'https://ccnsw.partssearch.com.au'
     }
     return  process.env.VUE_APP_HomeURL ? process.env.VUE_APP_HomeURL : 'https://partssearch.com.au'
}

export const appConfig = {
     baseAPIURL: process.env.VUE_APP_BaseAPIURL || 'https://api.partssearch.com.au',
     appURL: getAppUrl(),
     homeURL: getHomeUrl(),
     statewideLandingUrl: process.env.VUE_APP_STATEWIDE_HomeURL ? process.env.VUE_APP_STATEWIDE_HomeURL : 'https://statewide.partssearch.com.au',
     accountReceivingEmailDomain: '@partssearch.com.au',
     centrifugeUrl: process.env.VUE_APP_CentrifugeUrl || 'wss://api.partssearch.com.au:9000',
};

appConfig.APILogin = appConfig.baseAPIURL + '/ir/auth/login';
